import React, { Component } from 'react';
import { connect } from 'react-redux';

import LOOKUP from 'constants/lookup';
import util from 'library/util';
import { MixAndMatchSettingType } from 'constants/enums';
import { cleanMixAndMatchForm, formError, formInput } from 'actions/FormActions';
import { getPriceMatrices, getCategories, getProducts, saveMixAndMatch, getMixAndMatchById } from 'actions/EntityActions';
import { selectMixAndMatchModel, selectMixAndMatchSettingModel, selectMixAndMatchPriceSettingsIds } from 'selectors/entitySelector';
import { showSnackbar, showError } from 'actions/CommonActions';
{/*  COMPONENTS  */ }
import DialogInput from 'screens/components/advanced/DialogInput';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import ToggleInput from 'screens/components/basic/ToggleInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import SelectInput from 'screens/components/basic/SelectInput';
import RadioInput from 'screens/components/basic/RadioInput';
import CheckInput from 'screens/components/basic/CheckInput';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import WithRouter from 'custom/withRouter';

const componentName = 'mixAndMatchSave';

class MixAndMatchSave extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            status: '',
            activePage: 1,
            itemsPerPage: 25,
            settings: [],
            products: [],
            priceMatrices: [],
            itemsDialog: false,
            settingsValidation: false,
            itemsValidation: false
        };
    }

    componentWillMount() {
        this.props.cleanForm();
        const mixAndMatchId = this.props.params.id;
        if (mixAndMatchId) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    status: "EDIT"
                };
            }, () => {
                this.props.getMixAndMatchById(mixAndMatchId);
            });
        }
        else {
            this.setState(prevState => {
                return {
                    ...prevState,
                    status: "ADD"
                };
            });
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.props.dialogSelectedType !== newProps.dialogSelectedType) {
            if (newProps.priceMatrices.length === 0) {
                this.props.getPriceMatrices();
            }
            if (newProps.categoriesList.length === 0) {
                this.props.getCategories();
            }
        }

        if (this.props.saveTimestamp !== newProps.saveTimestamp) {
            if (newProps.saveSuccess === true)
                this.saveSuccess();
            else if (newProps.saveSuccess === false)
                this.saveFailure(newProps.saveError);
        }

        if (this.props.mixAndMatch !== newProps.mixAndMatch && newProps.mixAndMatch) {
            if (this.state.settings.length !== newProps.mixAndMatch.settings.length) {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        settings: [...newProps.mixAndMatch.settings]
                    };
                });
            }
            if ((this.state.products.length + this.state.priceMatrices.length) !== newProps.mixAndMatch.items.length) {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        products: [...newProps.mixAndMatch.items.filter(item => item.itemType === 2)],
                        priceMatrices: [...newProps.mixAndMatch.items.filter(item => item.itemType === 1)]
                    };
                }, () => {
                    this.state.priceMatrices.map(item => {
                        this.props.formInput(true, `${componentName}PriceMatrix-${item.itemId}`);
                    });
                });
            }
        }
    }

    componentWillUnmount() {
        this.props.cleanForm();
    }

    saveSuccess = () => {
        this.props.showSnackbar(this.state.status === "EDIT" ? LOOKUP.mixAndMatch.messages.editedMessage : LOOKUP.mixAndMatch.messages.createdMessage);
        this.props.navigate("/manage/pricing/mixandmatch");
    }

    saveFailure = (msg) => {
        this.props.showError(msg || LOOKUP.mixAndMatch.messages.saveErrorMessage);
    }

    openItemsDialog = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                itemsDialog: true
            };
        });
    }

    closeItemsDialog = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                itemsDialog: false
            };
        });
    }

    addPriceSettings = () => {
        const priceSettings = this.props.priceMatrices.filter(c => this.props.selectedPriceSettingsIds.indexOf(c.id) !== -1);
        this.setState(prevState => {
            return {
                ...prevState,
                priceMatrices: priceSettings.map(item => {
                    return {
                        itemId: item.id,
                        name: item.name,
                        itemType: 1
                    };
                })
            };
        }, this.validate);
        this.closeItemsDialog();
    }

    addProduct = (product) => {
        const item = {
            itemId: product.id,
            name: product.name,
            itemType: 2
        };

        this.setState(prevState => {
            return {
                ...prevState,
                products: [...prevState.products, item]
            };
        }, this.validate);
    }

    removeProduct = (product) => {
        this.setState(prevState => {
            return {
                ...prevState,
                products: prevState.products.filter(p => p.id !== product.id)
            };
        });
    }

    removeItem = (item, type) => {
        if (type == 1) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    priceMatrices: [...prevState.priceMatrices].filter(p => p !== item)
                };
            }, this.props.formInput(null, `${componentName}PriceMatrix-${item.itemId}`));
        }
        else {
            this.setState(prevState => {
                return {
                    ...prevState,
                    products: [...prevState.products].filter(p => p !== item)
                };
            });
        }
    }

    removeSetting = (setting, index) => {
        this.setState(prevState => {
            return {
                ...prevState,
                settings: [...prevState.settings].filter(item => item !== setting)
            };
        });
    }

    dialogSearch = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                activePage: 1
            };
        }, this.searchProducts);
    }

    changePage = e => {
        this.setState(prevState => {
            return {
                ...prevState,
                activePage: e
            };
        }, this.searchProducts);
    }

    searchProducts = () => {
        const model = {
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage,
            searchText: this.props.productSearchText,
            categoryId: this.props.categoryIdSearch,
            priceMatrixId: this.props.priceMatrixIdSearch,
            branchId: this.props.branchId
        };
        this.props.getProducts(model);
    }

    validate = () => {
        let valid = this.state.settings.length > 0 && (this.state.priceMatrices.length + this.state.products.length) > 0;
        this.setState(prevState => {
            return {
                ...prevState,
                settingsValidation: this.state.settings.length === 0,
                itemsValidation: (this.state.priceMatrices.length + this.state.products.length) === 0
            };
        });
        return valid;
    }

    addSetting = () => {
        const p = this.props;
        let setting = p.settingModel;
        const validators = [
            [`${componentName}Quantity`, setting => (setting.quantity && setting.quantity !== null && setting.quantity > 0), "Quantity"],
            [`${componentName}Type`, setting => (setting.type && setting.type !== null && setting.type !== 0), "Type"],
            [`${componentName}Amount`, setting => (setting.amount && setting.amount !== null && setting.amount > 0), "Amount"]
        ];

        if (util.validate(validators, setting, this.props.formError)) {
            setting.typeString = MixAndMatchSettingType[setting.Type];
            if (this.state.settings.filter(item => item.quantity === setting.quantity).length > 0) {
                this.props.showError(LOOKUP.mixAndMatch.sameSettingError);
            }
            else {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        settings: [...prevState.settings, setting]
                    };
                }, () => {
                    this.validate();
                    this.props.formInput(0, `${componentName}Amount`);
                    this.props.formInput(0, `${componentName}Quantity`);
                    this.props.formInput(null, `${componentName}Type`);
                });
            }
        }
    }

    saveMixAndMatch = () => {
        const p = this.props;
        let mixAndMatch = p.model;

        const validators = [
            [`${componentName}Name`, m => (m.Name && m.Name !== null && m.Name !== ""), "Name"],
            [`${componentName}StartDate`, m => (m.DateFrom && m.DateFrom !== null && m.DateFrom !== 0), "StartDate"]
        ];
        const fieldValidation = util.validate(validators, mixAndMatch, this.props.formError);
        const itemsValidation = this.validate();
        if (fieldValidation && itemsValidation) {
            mixAndMatch.settings = this.state.settings;
            mixAndMatch.items = this.state.products.map(item => {
                return {
                    itemId: item.itemId,
                    itemType: 2
                };
            }).concat(this.state.priceMatrices.map(item => {
                return {
                    itemId: item.itemId,
                    itemType: 1
                };
            }));

            this.props.saveMixAndMatch(mixAndMatch);
        }
    }

    render() {
        const p = this.props;
        const title = this.state.status === 'EDIT' ? LOOKUP.mixAndMatch.edit : LOOKUP.mixAndMatch.add;
        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li><Link to={LOOKUP.menu.pricing.mixAndMatch.link}>{LOOKUP.menu.pricing.mixAndMatch.text}</Link></li>
                    <li className="active">{title}</li>
                </ol>
                <h2>{title} <Button type="HeaderBackPage" onTouchTap={this.props.navigate(-1)} /></h2>
            </div>);

        const categories = (this.props.categoriesList).map(c => ({
            text: c.name,
            value: c.id.toString()
        }));

        const priceMatrices = (this.props.priceMatrices).map(p => ({
            text: p.name,
            value: p.id.toString()
        }));

        const settings = this.state.settings.map((item, index) => {
            return {
                Quantity: item.quantity.toFixed(2),
                TypeString: MixAndMatchSettingType[item.type],
                Amount: item.amount.toFixed(2),
                Buttons: <Button
                    key={index}
                    name={`${componentName}${item.id}SettingRemoveItem`}
                    type="IconButton"
                    className="glyphicon glyphicon-remove-circle"
                    onTouchTap={this.removeSetting.bind(this, item, index)}
                />
            };
        });

        let mixAndMatchSettingTypes = [];
        for (const key in MixAndMatchSettingType) {
            if (MixAndMatchSettingType.hasOwnProperty(key)) {
                mixAndMatchSettingTypes.push({
                    text: MixAndMatchSettingType[key],
                    value: key
                });
            }
        }

        const productsTable = p.products.map(item => {
            return {
                sku: item.sku,
                name: item.name,
                typeCategory: `[${item.type}] ${item.category}`,
                price: item.price,
                icons: this.state.products.filter(p => p.itemId == item.id).length > 0
                    ? (
                        <Button name={`${this.props.name}${item.id}RemoveProductFromCampaign`}
                            type="IconButton"
                            className="glyphicon glyphicon-ok-circle campaign_add_btn_clicked"
                            onTouchTap={this.removeProduct.bind(this, item)} />)
                    : (
                        <Button name={`${this.props.name}${item.id}AddProductToCampaign`}
                            type="IconButton"
                            className="glyphicon glyphicon-ok-circle campaign_add_btn"
                            onTouchTap={this.addProduct.bind(this, item)} />
                    )
            };
        });

        let items = this.state.priceMatrices.map((item, index) => {
            return {
                Name: item.name,
                Type: "Price Setting",
                Buttons: <Button
                    key={index}
                    name={`${componentName}${item.id}RemoveItem`}
                    type="IconButton"
                    className="glyphicon glyphicon-remove-circle"
                    onTouchTap={this.removeItem.bind(this, item, 1)}
                />
            };
        }).concat(this.state.products.map((item, index) => {
            return {
                Name: item.name,
                Type: "Product",
                Buttons: (<Button
                    key={index}
                    name={`${componentName}${item.id}RemoveItem`}
                    type="IconButton"
                    className="glyphicon glyphicon-remove-circle"
                    onTouchTap={this.removeItem.bind(this, item, 2)}
                />)
            };
        }));

        return (
            <ContainerDivided headerContent={header}>
                <div>
                    <div className="form-group">
                        <CardSimple title="Mix And Match">
                            {
                                (this.state.status === 'EDIT') ?
                                    (<div className="row">
                                        <div className="col-lg-8">
                                            <TextInput name={`${componentName}Id`}
                                                label={LOOKUP.mixAndMatch.id.label}
                                                floatingLabelText={LOOKUP.mixAndMatch.id.label}
                                                hintText={LOOKUP.mixAndMatch.id.hintText}
                                                disabled={true}
                                                fullWidth={true} />
                                        </div>
                                    </div>)
                                    : null
                            }
                            <div className="row">
                                <div className="col-lg-12">
                                    <TextInput name={`${componentName}Name`}
                                        label={LOOKUP.mixAndMatch.name.label}
                                        floatingLabelText={LOOKUP.mixAndMatch.name.label}
                                        hintText={LOOKUP.mixAndMatch.name.hintText}
                                        fullWidth={true}
                                        maxLength={50} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <TextInput name={`${componentName}Description`}
                                        label={LOOKUP.mixAndMatch.description.label}
                                        floatingLabelText={LOOKUP.mixAndMatch.description.label}
                                        hintText={LOOKUP.mixAndMatch.description.hintText}
                                        fullWidth={true}
                                        rows={2} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                    <DatePickerInput
                                        name={`${componentName}StartDate`}
                                        floatingLabelText={LOOKUP.mixAndMatch.startDate.label}
                                        hintText={LOOKUP.mixAndMatch.startDate.hintText}
                                        fullWidth={true}
                                        required
                                    />
                                </div>
                                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                    <DatePickerInput
                                        name={`${componentName}EndDate`}
                                        floatingLabelText={LOOKUP.mixAndMatch.endDate.label}
                                        hintText={LOOKUP.mixAndMatch.endDate.hintText}
                                        fullWidth={true}
                                        required
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                    <br />
                                    <br />
                                    <ToggleInput
                                        name={`${componentName}Status`}
                                        label={LOOKUP.mixAndMatch.status.label}
                                        className="campaign_status"
                                    />
                                </div>
                            </div>
                        </CardSimple>
                        <br />
                        <CardSimple title="Settings">
                            <div className="row">
                                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                    <DecimalInput
                                        name={`${componentName}Quantity`}
                                        floatingLabelText={LOOKUP.mixAndMatch.quantity.label}
                                        hintText={LOOKUP.mixAndMatch.quantity.hintText}
                                        fullWidth={true}
                                        required
                                    />
                                </div>
                                <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                    <SelectInput
                                        name={`${componentName}Type`}
                                        label={LOOKUP.mixAndMatch.type.label}
                                        floatingLabelText={LOOKUP.mixAndMatch.type.label}
                                        hintText={LOOKUP.mixAndMatch.type.hintText}
                                        fullWidth={true}
                                        options={mixAndMatchSettingTypes}
                                        required
                                    />
                                </div>
                                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                    <DecimalInput
                                        name={`${componentName}Amount`}
                                        floatingLabelText={LOOKUP.mixAndMatch.amount.label}
                                        hintText={LOOKUP.mixAndMatch.amount.hintText}
                                        fullWidth={true}
                                        required
                                    />
                                </div>
                                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                                    <br />
                                    <Button name="buttonSave"
                                        label={LOOKUP.mixAndMatch.controls.addSettingButton}
                                        primary={true}
                                        onTouchTap={this.addSetting} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <GenericTable
                                        className="table_center"
                                        multiSelectable={false}
                                        enableSelectAll={false}
                                        selectable={false}
                                        stripedRows={true}
                                        columns={LOOKUP.mixAndMatch.settingsTableColumns}
                                        rows={settings} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    {
                                        this.state.settingsValidation === true ? (
                                            <p className="validationMessage ml-1">Please, configure at least one setting for this Mix and Match.</p>
                                        ) : null
                                    }
                                </div>
                            </div>
                        </CardSimple>
                        <br />
                        <CardSimple title="Items">
                            <div className="row-flex justify-content-end">
                                <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                                    <Button
                                        className="pull-right"
                                        type="FloatButton"
                                        label="Add Items"
                                        fullWidth={true}
                                        onTouchTap={this.openItemsDialog}
                                    />
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-lg-12">
                                    <GenericTable
                                        className="table_center"
                                        multiSelectable={false}
                                        enableSelectAll={false}
                                        selectable={false}
                                        stripedRows={true}
                                        columns={LOOKUP.mixAndMatch.itemsTableColumns}
                                        rows={items} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    {
                                        this.state.itemsValidation === true ? (
                                            <p className="validationMessage ml-1">Please, choose at least one item for this Mix and Match.</p>
                                        ) : null
                                    }
                                </div>
                            </div>
                        </CardSimple>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <Button
                                name="buttonSave"
                                className="pull-right"
                                label={LOOKUP.campaign.controls.saveButon}
                                primary={true}
                                onTouchTap={this.saveMixAndMatch}
                            // disabled={!this.isPwdValid()}
                            />
                            <Button
                                type="CancelButton"
                                name="buttonCancel"
                                className="pull-right btn-space"
                                label={LOOKUP.common.cancel.text}
                                onTouchTap={this.props.navigate(-1)}
                            />
                        </div>
                    </div>
                </div>

                {/* DIALOG PRODUCTS */}
                <DialogInput
                    title="Add To Campaign"
                    modal={true}
                    autoScrollBodyContent={true}
                    style={{ zIndex: '980' }}
                    actions={[
                        <Button
                            name="buttonClose"
                            label="Close"
                            primary={false}
                            onTouchTap={this.closeItemsDialog} />
                    ]}
                    contentStyle={{ width: '95%', maxWidth: 'none' }}
                    open={this.state.itemsDialog}>
                    <div>
                        <div className="row">
                            <div className="col-lg-12">
                                <br />
                                <p>First, choose if you want to add by price settings or specific products to this mix and match:</p>
                                <RadioInput groupName={`${componentName}DialogType`}
                                    className="pos_refund_radio"
                                    options={[{ text: "By Price Setting", value: '1' }, { text: "By Product", value: '2' }]}
                                    fullWidth={true} />
                            </div>
                        </div>
                        <hr />
                        <div>
                            {
                                p.dialogSelectedType == 1 ? (
                                    <div>
                                        <div className="row">
                                            {
                                                p.priceMatrices.map((item, index) => {
                                                    return (
                                                        <div className="col-lg-6" key={index}>
                                                            <CheckInput
                                                                name={`${componentName}PriceMatrix-${item.id}`}
                                                                text={item.name}
                                                                value={item.id}
                                                            />
                                                        </div>
                                                    );
                                                })
                                            }
                                            <div className="col-lg-12">
                                                <br />
                                                <Button
                                                    className="pull-right"
                                                    name="buttonAddItem"
                                                    label="Add to Mix and Match"
                                                    primary={true}
                                                    onTouchTap={this.addPriceSettings} />
                                            </div>
                                        </div>
                                    </div>
                                ) : null
                            }
                            {
                                p.dialogSelectedType == 2 ? (
                                    <div>
                                        <div>
                                            <div className="row">
                                                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 input_no_padding">
                                                    <TextInput
                                                        name={`${p.name}DialogProductSearchText`}
                                                        fullWidth={true}
                                                        label={LOOKUP.campaign.filters.productName.label}
                                                        floatingLabelText={LOOKUP.campaign.filters.productName.label}
                                                        hintText={LOOKUP.campaign.filters.productName.hintText} />
                                                </div>
                                                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-4 input_no_padding">
                                                    <SelectInput name={`${p.name}DialogCategorySearch`}
                                                        label={LOOKUP.product.filters.category.label}
                                                        className="smallerPlaceholder"
                                                        floatingLabelText={LOOKUP.product.filters.category.label}
                                                        hintText={LOOKUP.product.filters.category.hintText}
                                                        options={categories}
                                                        fullWidth={true} />
                                                </div>
                                                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-4 input_no_padding">
                                                    <SelectInput name={`${p.name}DialogPriceMatrixSearch`}
                                                        fullWidth={true}
                                                        className="smallerPlaceholder"
                                                        floatingLabelText={"Price Matrix"}
                                                        label={LOOKUP.product.priceMatrix.label}
                                                        options={priceMatrices}
                                                        hintText={LOOKUP.product.priceMatrix.hintText} />
                                                </div>
                                                <div className="col-lg-2">
                                                    <br />
                                                    <Button
                                                        className="pull-right"
                                                        name="searchProductDialog"
                                                        label="Search"
                                                        primary={true}
                                                        onTouchTap={this.dialogSearch} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <GenericTable
                                                        className="table_center"
                                                        compName="productDialogListTable"
                                                        adjustForCheckbox={false}
                                                        displaySelectAll={false}
                                                        displayRowCheckbox={false}
                                                        enableSelectAll={false}
                                                        multiSelectable={false}
                                                        selectable={false}
                                                        stripedRows={true}
                                                        columns={LOOKUP.campaign.productDialogTableColumns}
                                                        rows={productsTable} />
                                                    <Pagination
                                                        length={p.productsLength || 0}
                                                        itemsPerPage={this.state.itemsPerPage}
                                                        activePage={this.state.activePage}
                                                        onPageChange={this.changePage} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                </DialogInput>
            </ContainerDivided>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        mixAndMatch: state.entity.mixAndMatch,
        model: selectMixAndMatchModel(state, componentName),
        settingModel: selectMixAndMatchSettingModel(state, componentName),
        selectedPriceSettingsIds: selectMixAndMatchPriceSettingsIds(state, componentName),
        dialogSelectedType: state.form[`${componentName}DialogType`],
        priceMatrices: state.entity.priceMatricesList || [],
        categoriesList: state.entity.categoriesList || [],
        products: state.entity.productList || [],
        productsLength: state.entity.productListLength,
        productSearchText: state.form[`${componentName}DialogProductSearchText`],
        categoryIdSearch: state.form[`${componentName}DialogCategorySearch`] ? parseInt(state.form[`${componentName}DialogCategorySearch`]) : null,
        priceMatrixIdSearch: state.form[`${componentName}DialogPriceMatrixSearch`] ? parseInt(state.form[`${componentName}DialogPriceMatrixSearch`]) : null,
        saveSuccess: state.form[`${componentName}SaveSuccess`],
        saveTimestamp: state.form[`${componentName}SaveTimestamp`],
        saveError: state.form[`${componentName}SaveError`],
        branchId: state.common.branchId
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        cleanForm: () => dispatch(cleanMixAndMatchForm(componentName)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        formError: (name, error) => dispatch(formError(name, error)),
        getPriceMatrices: () => dispatch(getPriceMatrices()),
        getProducts: (model) => dispatch(getProducts(model)),
        getCategories: () => dispatch(getCategories(parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')))),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        saveMixAndMatch: (model) => dispatch(saveMixAndMatch(model, componentName)),
        getMixAndMatchById: (id) => dispatch(getMixAndMatchById(id, componentName))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(MixAndMatchSave));